import React, { useEffect, useState } from 'react';
import DateInput from '../components/DateInput';
import api from '../api/axios';
import { format } from 'date-fns';
import { toast } from 'react-toastify';

const TYPES = ['Quality','Weight','Damage','Delay','Other'];
const STATUSES = ['Open','In Progress','Resolved'];
const fmtDate = d => d ? format(new Date(d), 'dd/MM/yyyy') : '—';

export default function Complaints() {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ type:'', status:'' });
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [orders, setOrders] = useState([]);
  const [saving, setSaving] = useState(false);

  const load = () => {
    const params = Object.fromEntries(Object.entries(filters).filter(([,v])=>v));
    api.get('/complaints', {params}).then(r => { setComplaints(r.data); setLoading(false); });
  };
  useEffect(() => { load(); api.get('/orders',{params:{limit:200}}).then(r=>setOrders(r.data.data||[])); }, []);

  const openNew = () => { setForm({ complaint_date: new Date().toISOString().split('T')[0], status:'Open' }); setModal('new'); };
  const openEdit = (c) => { setForm({...c}); setModal('edit'); };

  const save = async e => {
    e.preventDefault(); setSaving(true);
    try {
      if (modal === 'new') await api.post('/complaints', form);
      else await api.put(`/complaints/${form.id}`, form);
      toast.success('Saved'); setModal(null); load();
    } catch(err) { toast.error(err.response?.data?.message || 'Failed'); }
    finally { setSaving(false); }
  };

  const statusBadge = s => {
    const m = { Open:'badge-red','In Progress':'badge-yellow', Resolved:'badge-green' };
    return <span className={`badge ${m[s]||'badge-gray'}`}>{s}</span>;
  };

  return (
    <div>
      <div className="page-header">
        <div><h2>Complaint Management</h2><p>Step 11 — Log and track complaints</p></div>
        <button className="btn btn-primary" onClick={openNew}>+ Log Complaint</button>
      </div>

      <div className="filter-bar">
        <div className="form-group"><label>Type</label>
          <select className="form-control" value={filters.type} onChange={e=>setFilters({...filters,type:e.target.value})}>
            <option value="">All Types</option>{TYPES.map(t=><option key={t}>{t}</option>)}
          </select>
        </div>
        <div className="form-group"><label>Status</label>
          <select className="form-control" value={filters.status} onChange={e=>setFilters({...filters,status:e.target.value})}>
            <option value="">All Statuses</option>{STATUSES.map(s=><option key={s}>{s}</option>)}
          </select>
        </div>
        <button className="btn btn-primary btn-sm" onClick={load}>Apply</button>
      </div>

      <div className="card" style={{padding:0}}>
        {loading ? <div className="loading">Loading...</div> : complaints.length === 0 ? <div className="empty-state">No complaints found</div> :
          <div className="table-wrap">
            <table>
              <thead><tr><th>Date</th><th>Order No</th><th>Shipper</th><th>Type</th><th>Description</th><th>Reported To</th><th>Status</th><th></th></tr></thead>
              <tbody>
                {complaints.map(c => (
                  <tr key={c.id}>
                    <td>{fmtDate(c.complaint_date)}</td>
                    <td className="fw-bold">{c.order_no}</td>
                    <td>{c.shipper_name}</td>
                    <td><span className="badge badge-orange">{c.complaint_type}</span></td>
                    <td style={{maxWidth:'200px'}}>{c.description}</td>
                    <td>{c.reported_to||'—'}</td>
                    <td>{statusBadge(c.status)}</td>
                    <td><button className="btn btn-outline btn-xs" onClick={()=>openEdit(c)}>Edit</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      </div>

      {modal && (
        <div className="modal-overlay" onClick={()=>setModal(null)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <h3>{modal==='new' ? 'Log New Complaint' : 'Update Complaint'}</h3>
              <button className="btn-icon" onClick={()=>setModal(null)}>✕</button>
            </div>
            <form onSubmit={save}>
              <div className="form-row-2">
                <div className="form-group"><label>Order <span className="req">*</span></label>
                  <select className="form-control" value={form.order_id||''} onChange={e=>setForm(f=>({...f,order_id:e.target.value}))} required>
                    <option value="">— Select Order —</option>
                    {orders.map(o=><option key={o.id} value={o.id}>{o.order_no} — {o.shipper_name}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Complaint Date <span className="req">*</span></label><DateInput className="form-control" value={form.complaint_date||''} onChange={e=>setForm(f=>({...f,complaint_date:e.target.value}))} required /></div>
              </div>
              <div className="form-row-2">
                <div className="form-group"><label>Type</label><select className="form-control" value={form.complaint_type||''} onChange={e=>setForm(f=>({...f,complaint_type:e.target.value}))}><option value="">—</option>{TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
                <div className="form-group"><label>Status</label><select className="form-control" value={form.status||'Open'} onChange={e=>setForm(f=>({...f,status:e.target.value}))}>{STATUSES.map(s=><option key={s}>{s}</option>)}</select></div>
              </div>
              <div className="form-group"><label>Description</label><textarea className="form-control" rows={3} value={form.description||''} onChange={e=>setForm(f=>({...f,description:e.target.value}))} /></div>
              <div className="form-row-2">
                <div className="form-group"><label>Reported To</label><input className="form-control" value={form.reported_to||''} onChange={e=>setForm(f=>({...f,reported_to:e.target.value}))} /></div>
                {form.status === 'Resolved' && <div className="form-group"><label>Resolved Date</label><DateInput className="form-control" value={form.resolved_date||''} onChange={e=>setForm(f=>({...f,resolved_date:e.target.value}))} /></div>}
              </div>
              {form.status !== 'Open' && <div className="form-group"><label>Resolution Notes</label><textarea className="form-control" rows={2} value={form.resolution_notes||''} onChange={e=>setForm(f=>({...f,resolution_notes:e.target.value}))} /></div>}
              <div className="btn-group mt-2">
                <button className="btn btn-primary" type="submit" disabled={saving}>{saving?'Saving...':'Save'}</button>
                <button className="btn btn-secondary" type="button" onClick={()=>setModal(null)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
